import { render, staticRenderFns } from "./BillingSelectClinic.vue?vue&type=template&id=7b0f1b4e&"
import script from "./BillingSelectClinic.vue?vue&type=script&lang=js&"
export * from "./BillingSelectClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports